// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { createClient } from 'microcms-js-sdk';

export const environment = {
  production: true,
  baseURL: 'http://localhost:3000',
  mailTo: 'imajin8280@gmail.com',
  logger: 'logger',
  biller: 'logger',
  otherCategory: 'other',
};

export const client = createClient({
  serviceDomain: 'dynamo-b-studio',
  apiKey: 'AF2v3WX5IbJV9VBNgV3gFH5PlubptChAjrPK',
});

export const puppeteerSetting = {
  headless: true,
  args: ['--no-sandbox', '--disabled-setuid-sandbox'],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
